import { useState, useRef } from "react";
import Config from "../../Config";

import { PieChart, Pie, Cell, BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, } from 'recharts';
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputComboStawki from "../../helpers/InputComboStawki";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";

function Saldo(props)
{
        
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [filterParam, setFilterParam] = useState({ 
        p_subkonta_id: '_x_'             
    });


    const [tab, setTab] = useState(null);



    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_rap,rdz_stat', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         var modX = val.length % 3;
         if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  
 
         props.mainView.writeFilter(filedName, val);
     }



    if(refreshView != props.userData.refreshView)
    {
        setRefreshView(props.userData.refreshView);
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
    }


    const colors = ['#6aa44b', '#f25c37' ];
    const colors2 = ['#69b6bd', '#5482ac' ];

    var barData  = [];

    if(tab != null && tab.wykres != undefined)
    {
          barData = tab.wykres;     
    }


    return (
        <div className="raports">
      
      
            <div className="rap_filter_right">

                    <div className="filter_controll">   
                            <label>Konto / Subkonto: </label>                             
                            <InputComboSubkonto   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_subkonta_id}   valChange={valChangeListener} goNext={null} name="p_subkonta_id" placeholder={": "}  noempty="1"   />
                    </div> 
            </div>

      
            <div className="rap_inline">
                        <div className="rap_title">Saldo rodzica</div>   
                        <ResponsiveContainer width="100%" height={400}>
                                        <BarChart
                                            data={barData}
                                            margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="Nazwisko" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />                                           
                                            <Bar dataKey="Saldo" fill="#c67912" />
                                        </BarChart>
                        </ResponsiveContainer>
                    </div>


        </div>
    )
}


export default Saldo;